class CalorieCalculator extends HTMLElement {
  constructor() {
    super();
    this.currentStep = 1;
    this.totalSteps = 6; // Updated to 6 steps
    this.data = {};
    this.googleSheetsId = '1BFDzIJjx7yUTmYeFhz4e6Idbpq9aZrLmhsYp71Rey1g';
  }

  connectedCallback() {
    this.init();
    this.bindModalEvents();
  }

  init() {
    this.bindEvents();
    this.showStep(this.currentStep);
  }

  bindModalEvents() {
    const openButtons = document.querySelectorAll('.calorie-calculator__open');

    openButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.openModal();
      });
    });

    const closeButton = this.querySelector('.calorie-calculator__close');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        this.closeModal();
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('active')) {
        this.closeModal();
      }
    });
  }

  openModal() {
    this.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.classList.remove('active');
    document.body.style.overflow = '';

    this.currentStep = 1;
    this.data = {};
    this.showStep(1);
  }

  bindEvents() {
    // Step 1: Achieve
    this.querySelector('.calorie-calculator__achieve-block__next-btn').addEventListener('click', () => {
      if (this.validateAchieve()) {
        this.saveAchieve();
        this.nextStep();
      }
    });

    // Step 2: Height
    this.querySelector('.calorie-calculator__height-block__prev-btn').addEventListener('click', () => {
      this.prevStep();
    });
    this.querySelector('.calorie-calculator__height-block__next-btn').addEventListener('click', () => {
      if (this.validateHeight()) {
        this.saveHeight();
        this.nextStep();
      }
    });

    // Step 3: Weight
    this.querySelector('.calorie-calculator__weight-block__prev-btn').addEventListener('click', () => {
      this.prevStep();
    });
    this.querySelector('.calorie-calculator__weight-block__next-btn').addEventListener('click', () => {
      if (this.validateWeight()) {
        this.saveWeight();
        this.nextStep();
      }
    });

    // Step 4: Age
    this.querySelector('.calorie-calculator__age-block__prev-btn').addEventListener('click', () => {
      this.prevStep();
    });
    this.querySelector('.calorie-calculator__age-block__next-btn').addEventListener('click', () => {
      if (this.validateAge()) {
        this.saveAge();
        this.nextStep();
      }
    });

    // Step 5: Gender
    this.querySelector('.calorie-calculator__gender-block__prev-btn').addEventListener('click', () => {
      this.prevStep();
    });
    this.querySelector('.calorie-calculator__gender-block__next-btn').addEventListener('click', () => {
      if (this.validateGender()) {
        this.saveGender();
        this.nextStep();
      }
    });

    // Step 6: Activity Level
    this.querySelector('.calorie-calculator__activity-block__prev-btn').addEventListener('click', () => {
      this.prevStep();
    });
    this.querySelector('.calorie-calculator__activity-block__next-btn').addEventListener('click', () => {
      if (this.validateActivity()) {
        this.saveActivity();
        this.nextStep();
      }
    });

    // Email submit
    this.querySelector('.calorie-calculator__email-block__submit-btn').addEventListener('click', () => {
      if (this.validateEmail()) {
        this.saveEmail();
        this.calculateResults();
        this.submitToGoogleSheets();
      }
    });
  }

  showStep(step) {
    const blocks = this.querySelectorAll(
      '.calorie-calculator__achieve-block, .calorie-calculator__height-block, .calorie-calculator__weight-block, .calorie-calculator__age-block, .calorie-calculator__gender-block, .calorie-calculator__activity-block, .calorie-calculator__email-block, .calorie-calculator__success-block'
    );
    blocks.forEach((block) => {
      block.classList.remove('active');
    });

    setTimeout(() => {
      let currentBlock;
      switch (step) {
        case 1:
          currentBlock = this.querySelector('.calorie-calculator__achieve-block');
          break;
        case 2:
          currentBlock = this.querySelector('.calorie-calculator__height-block');
          break;
        case 3:
          currentBlock = this.querySelector('.calorie-calculator__weight-block');
          break;
        case 4:
          currentBlock = this.querySelector('.calorie-calculator__age-block');
          break;
        case 5:
          currentBlock = this.querySelector('.calorie-calculator__gender-block');
          break;
        case 6:
          currentBlock = this.querySelector('.calorie-calculator__activity-block');
          break;
        case 7:
          currentBlock = this.querySelector('.calorie-calculator__email-block');
          break;
        case 8:
          currentBlock = this.querySelector('.calorie-calculator__success-block');
          break;
      }
      if (currentBlock) {
        currentBlock.classList.add('active');
      }
    }, 100);
  }

  nextStep() {
    if (this.currentStep < this.totalSteps + 2) {
      this.currentStep++;
      this.showStep(this.currentStep);
    }
  }

  prevStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
      this.showStep(this.currentStep);
    }
  }

  // Validation methods
  validateAchieve() {
    const achieve = this.querySelector('input[name="achieve"]:checked');
    const errorMsg = this.querySelector('.calorie-calculator__achieve-block .error-message');

    if (!achieve) {
      errorMsg.style.display = 'block';
      return false;
    }
    errorMsg.style.display = 'none';
    return true;
  }

  validateHeight() {
    const height = this.querySelector('.calorie-calculator__height-block__input').value;
    const errorMsg = this.querySelector('.calorie-calculator__height-block .error-message');

    if (!height || height < 100 || height > 250) {
      errorMsg.style.display = 'block';
      return false;
    }
    errorMsg.style.display = 'none';
    return true;
  }

  validateWeight() {
    const weight = this.querySelector('.calorie-calculator__weight-block__input').value;
    const errorMsg = this.querySelector('.calorie-calculator__weight-block .error-message');

    if (!weight || weight < 30 || weight > 300) {
      errorMsg.style.display = 'block';
      return false;
    }
    errorMsg.style.display = 'none';
    return true;
  }

  validateAge() {
    const age = this.querySelector('.calorie-calculator__age-block__input').value;
    const errorMsg = this.querySelector('.calorie-calculator__age-block .error-message');

    if (!age || age < 1 || age > 120) {
      errorMsg.style.display = 'block';
      return false;
    }
    errorMsg.style.display = 'none';
    return true;
  }

  validateGender() {
    const gender = this.querySelector('input[name="gender"]:checked');
    const errorMsg = this.querySelector('.calorie-calculator__gender-block .error-message');

    if (!gender) {
      errorMsg.style.display = 'block';
      return false;
    }
    errorMsg.style.display = 'none';
    return true;
  }

  validateActivity() {
    const activity = this.querySelector('input[name="activity"]:checked');
    const errorMsg = this.querySelector('.calorie-calculator__activity-block .error-message');

    if (!activity) {
      errorMsg.style.display = 'block';
      return false;
    }
    errorMsg.style.display = 'none';
    return true;
  }

  validateEmail() {
    const email = this.querySelector('.calorie-calculator__email-block__input').value;
    const errorMsg = this.querySelector('.calorie-calculator__email-block .error-message');
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email || !emailRegex.test(email)) {
      errorMsg.style.display = 'block';
      return false;
    }
    errorMsg.style.display = 'none';
    return true;
  }

  // Save methods
  saveAchieve() {
    this.data.achieve = this.querySelector('input[name="achieve"]:checked').value;
  }

  saveHeight() {
    this.data.height = this.querySelector('.calorie-calculator__height-block__input').value;
  }

  saveWeight() {
    this.data.weight = this.querySelector('.calorie-calculator__weight-block__input').value;
  }

  saveAge() {
    this.data.age = this.querySelector('.calorie-calculator__age-block__input').value;
  }

  saveGender() {
    this.data.gender = this.querySelector('input[name="gender"]:checked').value;
  }

  saveActivity() {
    this.data.activity = this.querySelector('input[name="activity"]:checked').value;
  }

  saveEmail() {
    this.data.email = this.querySelector('.calorie-calculator__email-block__input').value;
  }

  // Calorie calculation methods
  calculateBMI() {
    const weight = parseFloat(this.data.weight);
    const heightInMeters = parseFloat(this.data.height) / 100;
    return weight / (heightInMeters * heightInMeters);
  }

  getBMICategory(bmi) {
    if (bmi < 18.5) return 'Underweight';
    if (bmi < 25) return 'Normal weight';
    if (bmi < 30) return 'Overweight';
    return 'Obese';
  }

  calculateBMR() {
    const weight = parseFloat(this.data.weight);
    const height = parseFloat(this.data.height);
    const age = parseFloat(this.data.age);
    const gender = this.data.gender;

    if (gender === 'male') {
      // Men: BMR = (10 × weight_kg) + (6.25 × height_cm) - (5 × age) + 5
      return (10 * weight) + (6.25 * height) - (5 * age) + 5;
    } else {
      // Women: BMR = (10 × weight_kg) + (6.25 × height_cm) - (5 × age) - 161
      return (10 * weight) + (6.25 * height) - (5 * age) - 161;
    }
  }

  getActivityFactor() {
    const activity = this.data.activity;
    const activityFactors = {
      'very_little': 1.2,   // Sedentary
      'low': 1.375,         // Light activity
      'moderate': 1.55,     // Moderate activity
      'high': 1.725,        // High activity
      'very_high': 1.9      // Very high activity
    };
    return activityFactors[activity] || 1.2;
  }

  calculateTDEE() {
    const bmr = this.calculateBMR();
    const activityFactor = this.getActivityFactor();
    return bmr * activityFactor;
  }

  calculateGoalCalories() {
    const tdee = this.calculateTDEE();
    const goal = this.data.achieve;

    switch (goal) {
      case 'lose_weight':
        return tdee - 400; // 400 calorie deficit for weight loss
      case 'maintain_weight':
        return tdee; // Maintenance calories
      case 'build_muscle':
        return tdee + 400; // 400 calorie surplus for muscle gain
      default:
        return tdee;
    }
  }

  calculateResults() {
    // Calculate all values
    const bmi = this.calculateBMI();
    const bmiCategory = this.getBMICategory(bmi);
    const bmr = this.calculateBMR();
    const tdee = this.calculateTDEE();
    const goalCalories = this.calculateGoalCalories();

    // Store calculated values
    this.data.bmi = bmi.toFixed(1);
    this.data.bmiCategory = bmiCategory;
    this.data.bmr = Math.round(bmr);
    this.data.tdee = Math.round(tdee);
    this.data.goalCalories = Math.round(goalCalories);

    // Update the UI
    this.updateResultsDisplay();
  }

  updateResultsDisplay() {
    // Update the results in the success block
    const bmiResult = this.querySelector('#bmi-result');
    const bmiCategory = this.querySelector('#bmi-category');
    const bmrResult = this.querySelector('#bmr-result');
    const tdeeResult = this.querySelector('#tdee-result');
    const goalCalories = this.querySelector('#goal-calories');

    if (bmiResult) bmiResult.textContent = this.data.bmi;
    if (bmiCategory) bmiCategory.textContent = this.data.bmiCategory;
    if (bmrResult) bmrResult.textContent = this.data.bmr;
    if (tdeeResult) tdeeResult.textContent = this.data.tdee;
    if (goalCalories) goalCalories.textContent = this.data.goalCalories;
  }

  getCurrentTimestamp() {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = String(now.getFullYear()).slice(-2);
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} - ${hours}:${minutes}`;
  }

  showSuccessMessage() {
    // Show step 8 (success block)
    this.showStep(8);
  }

  async submitToGoogleSheets() {
    const submitBtn = this.querySelector('.calorie-calculator__email-block__submit-btn button');
    const submitBtnLoading = this.querySelector('.calorie-calculator__email-block__submit-btn--loading');
    const errorMsg = this.querySelector('.calorie-calculator__email-block .error-message');

    // Show loading state
    submitBtn.classList.add('hidden');
    submitBtnLoading.classList.remove('hidden');
    submitBtn.disabled = true;
    this.classList.add('loading');

    try {
      // Prepare data for Google Sheets
      const formData = {
        Timestamp: this.getCurrentTimestamp(),
        Email: this.data.email,
        Achievement: this.data.achieve,
        Height: this.data.height,
        Weight: this.data.weight,
        Age: this.data.age,
        Gender: this.data.gender,
        Activity: this.data.activity,
        BMI: this.data.bmi,
        BMICategory: this.data.bmiCategory,
        BMR: this.data.bmr,
        TDEE: this.data.tdee,
        GoalCalories: this.data.goalCalories
      };

      // Google Apps Script Web App URL
      const scriptUrl = `https://script.google.com/macros/s/AKfycbwaLpUCRzNmEqP2lqDJZmSRO6ww3RrRxP6mN2UNT4bsjGJMPaeYgXFlvG5bvGZszdVb/exec`;

      const response = await fetch(scriptUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          spreadsheetId: this.googleSheetsId,
          data: formData,
        }),
      });
      errorMsg.style.display = 'none';

      this.showSuccessMessage();
    } catch (error) {
      console.error('Error submitting to Google Sheets:', error);
      errorMsg.textContent = 'Failed to submit. Please try again.';
      errorMsg.style.display = 'block';
      submitBtnLoading.classList.add('hidden');
      submitBtn.classList.remove('hidden');
      submitBtn.disabled = false;
    }

    this.classList.remove('loading');
  }
}

// Register the custom element
customElements.define('calorie-calculator', CalorieCalculator);